// letterExamplesOverrides.js
//
// Optional manual overrides for which example word illustrates a letter in a
// given position. Auto-derivation (see letterExamples.js) handles everything
// by default; add entries here only to force a specific, nicer example.
//
// Shape: { '<letter>': { initial: '<word>', medial: '<word>', final: '<word>' } }
// Any word listed must also exist in dariWords.js.

export const letterExamplesOverrides = {
  // e.g. 'ب': { initial: 'برف', final: 'آب' },
};
